import Const from "../core/js/const"
const { CLIENT, ADMIN } = Const.USER.TYPE

import Layout from '../views/layout/index.vue'

import DeviceList from '../views/device/device-list.vue'
import BatteryList from '../views/device/battery-list.vue'
import DeviceDetail from '../views/device/device-detail.vue'
import BatteryDetail from '../views/device/battery-detail.vue'

const routes = [
    { // 404
        path: '/404',
        name: '404',
        meta: { hidden: true },
        component: () => import('../views/404.vue')
    },
    {
        path: '/',
        meta: { hidden: true },
        redirect: {path: '/login'}
    },
    { // login
        path: '/login',
        name: 'login',
        meta: { hidden: true },
        component: () => import('../views/login.vue')
    },
    { // test
        path: '/test',
        name: 'test',
        meta: { hidden: true },
        component: () => import('../views/test.vue')
    },
    { // home
        path: '/home',
        name: 'Home',
        component: Layout,
        meta: {
            key: 'overview',
            title: '数据总览',
            icon: 'i-home',
            leaf: true,
            role: [ADMIN, CLIENT],
        },
        children: [{
            path: '',
            name: 'HomeIndex',
            component: () => import('../views/home/index.vue'),
            meta: {
                key: 'overview',
                title: '数据总览'
            },
        }],
    },
    { // device
        path: '/device',
        name: 'DeviceManagement',
        component: Layout,
        meta: {
            key: 'device_management',
            title: '设备管理',
            icon: 'i-device',
            role: [ADMIN, CLIENT],
        },
        children: [
            { // 26001/list
                path: '26001/list',
                component: DeviceList,
                name: 'DeviceList26001',
                meta: {
                    key: 'vehicle_26001',
                    title: '车辆-嘉为',
                    space: '26001',
                }
            },
            { // 26001/detail
                path: '26001/detail',
                component: DeviceDetail,
                name: 'DeviceDetail26001',
                meta: {
                    key: 'vehicle_detail',
                    title: '车辆详情',
                    hidden: true,
                    space: '26001',
                }
            },
            { // 26003/list
                path: '26003/list',
                component: DeviceList,
                name: 'DeviceList26003',
                meta: {
                    key: 'vehicle_26003',
                    title: '车辆-26003',
                    space: '26003',
                }
            },
            { // 26003/detail
                path: '26003/detail',
                component: DeviceDetail,
                name: 'DeviceDetail26003',
                meta: {
                    key: 'vehicle_detail',
                    title: '车辆详情',
                    hidden: true,
                    space: '26003',
                }
            },            
            { // 26007/list
                path: '26007/list',
                component: DeviceList,
                name: 'DeviceList26007',
                meta: {
                    key: 'vehicle_26007',
                    title: '车辆-26007',
                    space: '26007',
                }
            },
            { // 26007/detail
                path: '26007/detail',
                component: DeviceDetail,
                name: 'DeviceDetail26007',
                meta: {
                    key: 'vehicle_detail',
                    title: '车辆详情',
                    hidden: true,
                    space: '26007',
                }
            },            
            // { // 26004/list
            //     path: '26004/list',
            //     component: DeviceList,
            //     name: 'DeviceList26004',
            //     meta: {
            //         key: 'vehicle_26004',
            //         title: '车辆-26004',
            //         space: '26004',
            //     }
            // },
            // { // 26004/detail
            //     path: '26004/detail',
            //     component: DeviceDetail,
            //     name: 'DeviceDetail26004',
            //     meta: {
            //         key: 'vehicle_detail',
            //         title: '车辆详情',
            //         hidden: true,
            //         space: '26004',
            //     }
            // },
            { // 26005/list
                path: '26005/list',
                component: BatteryList,
                name: 'BatteryList26005',
                meta: {
                    key: 'bms_26005',
                    title: 'BMS-26005',
                    space: '26005',
                }
            },
            { // 26005/detail
                path: '26005/detail',
                component: BatteryDetail,
                name: 'BatteryDetail26005',
                meta: {
                    key: 'bms_detail',
                    title: 'BMS详情',
                    hidden: true,
                    space: '26005',
                }
            },
            /* { // 26006/list
                path: '26006/list',
                component: BatteryList,
                name: 'BatteryList26006',
                meta: {
                    key: 'bms_26006',
                    title: 'BMS-26006',
                    space: '26006',
                }
            },
            { // 26006/detail
                path: '26006/detail',
                component: BatteryDetail,
                name: 'BatteryDetail26006',
                meta: {
                    key: 'bms_detail',
                    title: 'BMS详情',
                    hidden: true,
                    space: '26006',
                }
            }, */
        ],
    },
    { // task
        path: "/task",
        name: "OTA",
        component: Layout,
        meta: {
            key: "OTA",
            title: "OTA",
            icon: 'i-IOT',
            leaf: true,
            role: [ADMIN, CLIENT],
        },
        children: [
            {
                path: '',
                component: () => import('../views/task/task-list.vue'),
                name: "TaskList",
                meta: {
                    key: "task_list",
                    title: '任务列表',
                }
            },
            {
                path: 'detail',
                component: () => import('../views/task/task-detail.vue'),
                name: "TaskDetail",
                meta: {
                    key: "task_detail",
                    title: '任务详情',
                    hidden: true
                }
            },
        ],
    },
    { // user
        path: "/user",
        name: "UserManagement",
        component: Layout,
        meta: {
            key: "user_management",
            title: "用户管理",
            icon: 'i-user',
            leaf: true,
            role: [ADMIN],
        },
        children: [
            {
                path: '',
                component: () => import('../views/user/user-list.vue'),
                name: "UserList",
                meta: {
                    key: "user_list",
                    title: '用户列表',
                }
            },
            {
                path: 'detail',
                component: () => import('../views/user/user-detail.vue'),
                name: "UserDetail",
                meta: {
                    key: "user_detail",
                    title: '用户详情',
                    hidden: true,
                }
            },
        ],
    },
    { // admin
        path: "/admin",
        name: "AdminManagement",
        component: Layout,
        meta: {
            key: "admin_management",
            title: "管理员管理",
            icon: 'i-admin',
            leaf: true,
            role: [ADMIN],
        },
        children: [
            {
                path: '',
                component: () => import('../views/admin/admin-list.vue'),
                name: "AdminList",
                meta: {
                    key: "admin_list",
                    title: '管理员列表',
                }
            },
            {
                path: 'detail',
                component: () => import('../views/admin/admin-detail.vue'),
                name: "AdminDetail",
                meta: {
                    key: "admin_detail",
                    title: '管理员详情',
                    hidden: true,
                }
            },
        ],
    },
    { // tool
        path: "/tool",
        name: "ToolManagement",
        component: Layout,
        meta: {
            key: "tool_management",
            title: "工具",
            icon: 'i-tool',
            role: [ADMIN],
        },
        children: [
            {
                path: 'parser-26005',
                component: () => import('../views/tool/parser-26005.vue'),
                name: "Parser26005",
                meta: {
                    key: "parser_26005",
                    title: '26005解码',
                }
            },
        ],
    },

];

export default routes
